export class MapWrapper {
    _visible = false;
    _backgroundCached;

    constructor(potreeViewer) {
        this.potreeViewer = potreeViewer;
    }

    get visible() {
        return this._visible;
    }

    set visible(x) {
        this._visible = x;
        if (x) {
            const customHeightmapWidth = 32;
            const customHeightmapHeight = 32;
            const Cesium = window.Cesium;
            const customHeightmapProvider = new Cesium.CustomHeightmapTerrainProvider(
                {
                    width: customHeightmapWidth,
                    height: customHeightmapHeight,
                    callback: function (x, y, level) {
                        const res = new Float32Array(32 * 32);
                        for (let i = 0; i < res.length; i++) {
                            res[i] = this.staticHeight || 0;
                        }
                        return res;
                    },
                }
            );
            customHeightmapProvider.staticHeight =
                this.potreeViewer.scene.pointclouds.reduce((u, x) => x.position.z < u ? x.position.z : u, Number.MAX_VALUE);
            window.cesiumViewer = new Cesium.Viewer("cesiumContainer", {
                useDefaultRenderLoop: false,
                sceneMode: Cesium.SceneMode.MORPHING,
                animation: false,
                baseLayerPicker: false,
                fullscreenButton: false,
                geocoder: false,
                homeButton: false,
                infoBox: false,
                sceneModePicker: false,
                selectionIndicator: false,
                timeline: false,
                navigationHelpButton: false,
                baseLayer: new Cesium.ImageryLayer(new Cesium.OpenStreetMapImageryProvider({
                    url: "https://a.tile.openstreetmap.org/"
                })),
                mapProjection: new Cesium.WebMercatorProjection(),
                terrainShadows: Cesium.ShadowMode.DISABLED,
                terrainProvider: customHeightmapProvider
            });
            this._backgroundCached = this.potreeViewer.getBackground();
            this.potreeViewer.setBackground(null);
        }
        else {
            this.potreeViewer.setBackground(this._backgroundCached || "skybox");
            this.dispose();
        }
    }

    dispose() {
        if(!window.cesiumViewer) return;
        window.cesiumViewer.entities.removeAll();
        window.cesiumViewer.destroy();
        window.cesiumViewer = null;
    }
}
